<script lang="ts">
  import { formatRelativeTime } from "./utils";

  export let totalOpportunities: number;
  export let fullySynced: number;
  export let lastSyncTime: string;

  $: syncedPercent =
    totalOpportunities > 0 ? Math.round((fullySynced / totalOpportunities) * 100) : 0;
</script>

<div
  class="box-border flex h-full w-full min-w-0 flex-col justify-between rounded-xl border border-white/10 border-l-4 border-l-teal-300 bg-[#1b1e2e]/70 p-4 transition-all hover:border-white/20 hover:shadow-lg sm:p-6"
>
  <div class="mb-4 flex min-w-0 flex-wrap items-center gap-3">
    <div class="shrink-0 text-2xl">🔗</div>
    <div class="min-w-[120px] flex-1 text-[1.125rem] font-bold text-white">ACELINK CORE</div>
    <div
      class="px-3 py-1 bg-[rgba(94,234,212,0.15)] text-teal-300 rounded-2xl text-xs font-semibold border border-[rgba(94,234,212,0.3)]"
    >
      Shared Database
    </div>
  </div>

  <div class="h-px bg-white/10 my-4" />

  <div class="flex flex-col gap-3">
    <div class="flex min-w-0 justify-between gap-3 text-[0.938rem] py-2">
      <span class="text-white/60 font-medium">Total Records:</span>
      <span class="text-white font-semibold flex items-center gap-2">{totalOpportunities}</span>
    </div>
    <div class="flex min-w-0 justify-between gap-3 text-[0.938rem] py-2">
      <span class="text-white/60 font-medium">Sync Rate:</span>
      <span class="text-green-500 font-semibold flex items-center gap-2">{syncedPercent}%</span>
    </div>
    <div class="flex min-w-0 justify-between gap-3 text-[0.938rem] py-2">
      <span class="text-white/60 font-medium">Engine:</span>
      <span class="text-green-500 font-semibold flex items-center gap-2">
        <span
          class="w-2 h-2 rounded-full inline-block bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.6)] animate-pulse"
        />
        Active
      </span>
    </div>
  </div>

  <div
    class="flex justify-between mt-4 pt-4 border-t border-white/10 text-[0.813rem]"
  >
    <span class="text-white/50">Last Process</span>
    <span class="text-white font-semibold">{formatRelativeTime(lastSyncTime)}</span>
  </div>
</div>
